import { ITimelineForm } from '../../redux/timeline-data.model';
import { Component, Input, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { InteractivityEditorService } from '../../services/interactivity-editor.service';
import { IWidget } from '../../interfaces/IWidget';
import { InteractivityWidgetSelectionService } from '../../services/interactivity-widget-selection.service';

@Component({
	selector: 'ie-form-config',
	templateUrl: './ie-form-config.component.html',
	styleUrls: ['./ie-form-config.component.scss']
})

export class IEFormConfigComponent {
	@Input() propertyKey: string;
	@Output() procedureContextMenu: EventEmitter<any>;
	@Output() eventHandlerContextMenu: EventEmitter<any>;
	@ViewChild('formEmailFrom') formEmailFrom: ElementRef;

	forms: ITimelineForm[] = [];
	formWidgets: IWidget[] = [];
	private subscriptions = new Subscription();

	constructor(
		private widgetSelectionService: InteractivityWidgetSelectionService,
		private interactivityEditorService: InteractivityEditorService
	) {
		this.procedureContextMenu = new EventEmitter<any>();
		this.eventHandlerContextMenu = new EventEmitter<any>();
		this.subscriptions.add(this.interactivityEditorService.formsSubject.subscribe((formsData: any) => {
			this.forms = formsData;
			// console.warn('this.forms', this.forms)
		}));
		const types = 'formTextField formTextArea formSelect'.split(' ');
		this.subscriptions.add(this.interactivityEditorService.widgetsSubject.subscribe((widgets: IWidget[]) => {
			this.formWidgets = widgets.filter(w => types.indexOf(w.type) !== -1);
		}));
	}

	formTrackBy(i: number, item: ITimelineForm) {
		return item.id || 'form_' + i;
	}

	onFormFieldFocus() {
		if (this.formEmailFrom && this.formEmailFrom.nativeElement) {

			// prevent error caused by autofill in the emailFrom form field
			this.formEmailFrom.nativeElement.removeAttribute('readonly');
		}
	}

	onFormFieldChanged(fieldName: string) {
		const form = this.forms[0] || {};
		this.changeProperty(fieldName, form[fieldName]);
	}

	propertyChanged(formObj: any) {
		if (formObj.key !== null && formObj.value !== null) {
			this.changeProperty(formObj.key, formObj.value, formObj.msg);
		}
	}

	changeProperty(key: string, val: any, msg?: string): void {
		this.interactivityEditorService.changeFormField(key, val, msg);
	}

	onProcedureContextMenu(ev: any, key: string, index: number, item: any): void {
		if (ev) {
			ev.preventDefault();
			ev.stopPropagation();
		}
		this.procedureContextMenu.emit({ ev, key, index, item });
	}

	onEventHandlerContextMenu(ev: Event, key: string, index: number, item: any) {
		if (ev) {
			ev.preventDefault();
			ev.stopPropagation();
		}

		// make form event handler compatible with widget action event handlers
		item = {
			key,
			value: item
		};

		this.eventHandlerContextMenu.emit({ ev, key, index, item });
	}

	selectWidget(widget: IWidget) {
		this.widgetSelectionService.clearSelectedWidgets();
		this.widgetSelectionService.addSelectedWidget(widget, { area: 'generic' });
	}
}
